import React, { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";

import { faTimes } from "@fortawesome/pro-solid-svg-icons";

// components
import { ButtonIcon, Text } from "@performyard/py-components";

import Spacer from "../../../Spacer";
import { IQuery } from "../../QueryBuilderUtils";
import { ANNIVERSARY_QUERY_OPTIONS } from "../../constants";
//css
import css from "./QueryCard.module.scss";

declare interface QueryCardProps {
	title: string;
	orQueryArray?: IQuery[];
	removeOrQueryArray: () => void;
	onClick?: () => void;
	onOutsideClick?: (event) => void;
	isSelected?: boolean;
}

/*
 * The QueryCard component is used to display an array of queries from the QueryBuilder
 * It's used in implementation alongside the query builder to display the queries that have been built
 */
const QueryCard = ({
	title,
	orQueryArray = [],
	removeOrQueryArray,
	onClick,
	onOutsideClick,
	isSelected,
}: QueryCardProps) => {
	const deleteButtonRef = useRef<HTMLDivElement>(null);
	const cardRef = useRef<HTMLDivElement>(null);

	const handleClick = (event) => {
		if (cardRef.current && deleteButtonRef.current && onClick) {
			if (cardRef.current.contains(event.target) && !deleteButtonRef.current.contains(event.target)) {
				onClick();
			}
		}
	};

	const handleOutsideClick = (event) => {
		if (cardRef.current && onOutsideClick && isSelected) {
			if (cardRef.current && !cardRef.current.contains(event.target)) {
				onOutsideClick(event);
			}
		}
	};

	useOnClickOutside(deleteButtonRef, handleClick);
	useOnClickOutside(cardRef, handleOutsideClick);

	return (
		<div className={`${css.queryCard} ${isSelected && css.selected}`} ref={cardRef}>
			<div className={css.header}>
				<Text size="caption" weight="semi-bold" color="neutral-9">
					{title}
				</Text>
				<div ref={deleteButtonRef}>
					<ButtonIcon
						color="neutral"
						onClick={removeOrQueryArray}
						icon={faTimes}
						size={16}
						aria-label="Remove query"
					/>
				</div>
			</div>
			<Spacer height={1} />
			{orQueryArray.map((orQuery: IQuery, index: number) => (
				<div key={`query-card-query-${index}`}>
					<div className={css.query}>
						<Text size="caption" weight="semi-bold" color="neutral-9">
							{orQuery.field.name}
						</Text>
						<div className={css.comparator}>
							<Text size="caption" weight="semi-bold" color="neutral-9">
								{orQuery.comparator.label.toUpperCase()}
							</Text>
						</div>
						<Text size="caption" weight="semi-bold" color="neutral-9">
							{orQuery.comparator.label === ANNIVERSARY_QUERY_OPTIONS[0].label
								? ""
								: orQuery.queryValue.label}
						</Text>
					</div>
					{index !== orQueryArray.length - 1 && <Spacer height={1} />}
				</div>
			))}
		</div>
	);
};

export default QueryCard;
